/**
 * The query keys of seed orders by email (D69): the garden's address and the seeds waiting in its Seed vault, read by
 * the profile screen, the vault's card and its held block, so one read serves them all and a change refreshes them
 * together. "New address" puts its answer under SEED_ORDERS_MINE_KEY; filing or removing a held seed invalidates both.
 *
 * Where: SeedOrdersScreen, SeedAddressCard, HeldSeeds, UserProfile (the row's sub-line).
 *
 * @module seedOrderQueries
 */

/**
 * GET /seed-orders/mine. @kept K1
 */
export const SEED_ORDERS_MINE_KEY = ['seedOrders', 'mine'] as const;

/**
 * GET /seed-orders/held. @kept K1
 */
export const SEED_ORDERS_HELD_KEY = ['seedOrders', 'held'] as const;

/**
 * The beds the "Which bed did they go into?" sheet lists: under the locations key, so every change to the beds that
 * refreshes the locations refreshes it too. @kept K1
 */
export const WHICH_BED_LOCATIONS_KEY = ['locations', 'whichBed'] as const;
